import type { ITaxonomyGroup, ITaxonomyTerms } from "services/content-manager/models";

const findTaxonomy = (tree: ITaxonomyGroup, codename: string): any[] | null => {
    // Helper function to recursively search for the codename
    const findInTree = (
        node: ITaxonomyTerms | ITaxonomyGroup,
        targetCodename: string,
        chain: any[] = []
    ): any[] | null => {
        const nodeWithoutTerms: any = { ...node };

        if ((node as ITaxonomyTerms).codename === targetCodename) {
            // If we found the target codename, add it to the chain
            chain.push(nodeWithoutTerms);
            return chain;
        }

        // Loop through the terms of the current node
        for (const term of node.terms || []) {
            const updatedChain = [...chain, nodeWithoutTerms];
            const result: any[] | null = findInTree(term, targetCodename, updatedChain);

            // If the codename is found in the subtree, return the result
            if (result) return result;
        }

        // If not found, return null
        return null;
    };

    // Call the helper function to start the search
    const resultChain = findInTree(tree, codename);

    if (resultChain && resultChain.length) {
        resultChain.shift(); // Remove the first element (root node)
        return resultChain;
    } else {
        return null; // Codename not found in the tree
    }
};

export default findTaxonomy;
